import React from 'react';
import { useParams, useLocation, Navigate } from 'react-router-dom';
import ListViewLayout from '../../layout/ListViewLayout';
import DetailLayout from '../../layout/DetailLayout';
import EditLayout from '../../layout/EditLayout';

const OBJECT_NAME = 'mail_config';

/** Redirect /listview/mail_config to /setup/mailconfig */
export const RedirectMailConfigList = () => <Navigate to="/setup/mailconfig" replace />;

/** Redirect /view/mail_config/:id to /setup/mailconfig/:id */
export const RedirectMailConfigView = () => {
  const { id } = useParams();
  return <Navigate to={`/setup/mailconfig/${id}`} replace />;
};

/** Redirect /edit/mail_config or /edit/mail_config/:id to setup mailconfig create or edit */
export const RedirectMailConfigEdit = () => {
  const { id } = useParams();
  if (id) return <Navigate to={`/setup/mailconfig/${id}/edit`} replace />;
  return <Navigate to="/setup/mailconfig/create" replace />;
};

/**
 * Mail Config list under Setup — same as /listview/mail_config but at /setup/mailconfig.
 */
export const SetupMailConfigList = () => {
  const location = useLocation();
  return <ListViewLayout objectName={OBJECT_NAME} location={location} />;
};

/**
 * Mail Config detail under Setup — same as /view/mail_config/:id but at /setup/mailconfig/:id.
 */
export const SetupMailConfigView = ({ socket, selectedWhatsAppSetting }) => {
  const { id } = useParams();
  return (
    <DetailLayout
      objectName={OBJECT_NAME}
      id={id}
      socket={socket}
      selectedWhatsAppSetting={selectedWhatsAppSetting}
    />
  );
};

/**
 * Mail Config edit under Setup — same as /edit/mail_config/:id but at /setup/mailconfig/:id/edit.
 */
export const SetupMailConfigEdit = () => {
  const { id } = useParams();
  const location = useLocation();
  let sourcePage = 'listview';
  if (location.state?.sourcePage) sourcePage = location.state.sourcePage;
  else if (document.referrer?.includes('/view/')) sourcePage = 'detail';
  const searchParams = new URLSearchParams(location.search);
  const targetfield = searchParams.get('targetfield');
  const targetid = searchParams.get('targetid');
  const queryParams = targetfield && targetid ? { targetField: targetfield, targetId: targetid } : null;
  return (
    <EditLayout
      objectName={OBJECT_NAME}
      id={id}
      sourcePage={sourcePage}
      queryParams={queryParams}
    />
  );
};
